import { component } from 'picoapp';
// import './component.scss';

class Home {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.el = el;
    // this.init();
  }

  init() {
    // console.log('product view');
  }
}

export default component((node, ctx) => {
  new Home(node, ctx);
});
